export default __webpack_public_path__ + "static/media/map.d4b04266.png";